export class Kpi {
    
    private colors : any;

    private icons : any;
    
    private routes : any;
    
    private routesParams : any;
    
    private routesTitle : any;
    
    public concept : string;
    
    public value : Number;
    
    public label : string;
    
    constructor(data : any) {
        this.concept = data.concept;
        this.value = data.value;
        this.label = data.label;    
    
        this.colors = {
            'full' : 'bg-green',
            'used' : 'bg-aqua',
            'empty': 'bg-yellow',
            'not-located' :  'bg-red',
            'all-located' :  'bg-gray'
        };
        
        this.icons = {
            'full' : 'fa fa-battery-full',
            'used' : 'fa fa-battery-half',
            'empty': 'fa fa-battery-empty',
            'not-located' :  'fa fa-bookmark-o',
            'all-located' :  'fa fa-thumbs-o-up'
        };
                
        this.routes = {
            'full' : '/assets/stock',
            'used' : '/assets/stock',
            'empty': '/assets/stock',
            'not-located' :  '/assets/not-located',
            'all-located' :  '/assets/not-located'
        };
        
        this.routesParams = {
            'full' : {status : 'F'},
            'used' : {status : 'U'},
            'empty': {status : 'E'},
            'not-located' :  {autosearch: true},
            'all-located' :  {autosearch: true}
        };
        
        this.routesTitle = {
            'full' : 'Ver stock',
            'used' : 'Ver stock',
            'empty': 'Ver stock',
            'not-located' :  'Ver activos',
            'all-located' :  'Ver activos'
        };
        
    }

    
    getColor() {
        return this.colors[this.concept];
    }
    
    getIcon() {
        return this.icons[this.concept];
    }

    getRoute() {
        return this.routes[this.concept];
    };
    
    getRouteParams() {
        return this.routesParams[this.concept];
    }

    getRouteTitle() {
        return this.routesTitle[this.concept];
    };
}
